export default function(target, type, selection) {
  this.target = target;
  this.type = type;
  this.selection = selection;
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-brush/src/event.js
// module id = ../../../../d3-brush/src/event.js
// module chunks = 4